export enum ReactionTypesEnum {
	Kudos = 'f6e4fe57-1273-4b9f-abca-71675015a594',
	Like = '71675015-4b9f-abca-1273-5a594f6e4fe5',
}
